import { useEffect, useState } from "react";
import { listKnowledge, getKnowledge } from "@/services/knowledgeService";

export const useKnowledgeList = (category = null) => {
  const [data, setData]         = useState({ categories: [], stories: [] });
  const [isLoading, setLoading] = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    listKnowledge(category || undefined, { signal: controller.signal })
      .then((payload) => {
        if (controller.signal.aborted) return;
        setData(payload);
        setError(null);
      })
      .catch((e) => { if (!controller.signal.aborted) setError(e); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [category]);

  return { ...data, isLoading, error };
};

export const useKnowledgeStory = (idOrSlug) => {
  const [story, setStory]       = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError]       = useState(null);

  useEffect(() => {
    if (!idOrSlug) { setLoading(false); return; }
    const controller = new AbortController();
    setLoading(true);
    getKnowledge(idOrSlug, { signal: controller.signal })
      .then((row) => {
        if (controller.signal.aborted) return;
        setStory(row);
        setError(null);
      })
      .catch((e) => { if (!controller.signal.aborted) setError(e); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [idOrSlug]);

  return { story, isLoading, error };
};
